var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { NovastarHSeriesBase } from './util/NovastarHSeriesBase';
export class NovastarHSeriesUdp extends NovastarHSeriesBase {
    // other class properties and constructor
    constructor(socket, state, log, framework) {
        super(NovastarHSeriesUdp.driverType, state, log, framework);
        this.socket = socket;
    }
    // controls
    // phase callbacks
    // other class methods
    send(command, match, tags, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.socket.send(command, (resp) => {
                return match(resp.command);
            }, tags, options);
            return resp.command;
        });
    }
}
// static properties
NovastarHSeriesUdp.driverType = 'udpDriver';
NovastarHSeriesUdp.key = '-NhSF9pDOGwqfdj2P7mY';
NovastarHSeriesUdp.socketOptions = (config) => {
    var _a;
    return [
        {
            parser: (address, port, command) => {
                try {
                    // Driver assumes responses are not an array
                    const resp = JSON.parse(command);
                    if (Array.isArray(resp)) {
                        return resp[0];
                    }
                    return resp;
                }
                catch (err) {
                    return undefined;
                }
            },
            port: (_a = config.port) !== null && _a !== void 0 ? _a : 6000,
        },
    ];
};
